import React, { useRef, useCallback } from "react";
import { Modal } from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import { toast } from "react-toastify";
import api from "../../../../api/api";

const selectStyle = {
    theme: theme => ({
        ...theme,
        borderRadius: 0,
        colors: {
            ...theme.colors,
            primary25: '#92278f',
            primary: '#92278f',
        },
    })
};

const ChangeSchoolModal = ({ show, onClose, user, onSubmit, promiseSchoolOptions, onSuccess, t }) => {
    const schoolsSelectRef = useRef(null);

    const handlePromiseSchoolOptions = useCallback((inputValue, callback) => {
        if (promiseSchoolOptions) {
            promiseSchoolOptions(inputValue, callback);
            return;
        }
        api.get(`/Schools/?byView=true`)
            .then((resp) => {
                const list = resp.data?.data || [];
                const options = list.map(({ Id, Name }) => ({ label: Name, value: Id }));
                if (inputValue) {
                    const filtered = options.filter(opt =>
                        opt.label && opt.label.toLowerCase().includes(inputValue.toLowerCase())
                    );
                    callback(filtered);
                } else {
                    callback(options);
                }
            })
            .catch(() => callback([]));
    }, [promiseSchoolOptions]);

    if (!show || !user) return null;

    const handleSaveSchool = () => {
        const selected = schoolsSelectRef.current?.select?.select?.getValue();
        const value = selected && selected[0]?.value;
        const label = selected && selected[0]?.label;

        if (onSubmit) {
            onSubmit(value, label);
            return;
        }

        const _toastId = toast(t("Processing"), { position: "bottom-left", autoClose: false });

        if (user.UserType?.Id === 2) {
            const postData = {
                SchoolId: value,
                UserTypeId: user.UserType.Id === 2 ? 4 : 2,
            };
            api.put(`/ChangeUserType/${user.Id}`, postData)
                .then(() => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"><i className="icon fal fa-shield-check"></i> {t("Pages.UsersControl.toast.ChangePermission.Title")}</div></div>,
                        type: toast.TYPE.INFO,
                        autoClose: 5000,
                    });
                    if (onSuccess) onSuccess();
                    onClose();
                })
                .catch(() => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"><i className="icon fal fa-wifi-slash"></i> {t("Error.NoConnection.Title")}</div></div>,
                        type: toast.TYPE.ERROR,
                        autoClose: 5000,
                    });
                });
        } else {
            api.post(`/ChangeUserSchool/${user.Id}`, { SchoolId: value })
                .then(() => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"><i className="icon fal fa-school"></i> {t("Pages.UsersControl.toast.ChangeSchool.Title")}</div></div>,
                        type: toast.TYPE.SUCCESS,
                        autoClose: 5000,
                    });
                    if (onSuccess) onSuccess();
                    onClose();
                })
                .catch(() => {
                    toast.update(_toastId, {
                        render: () => <div><div className="h5"><i className="icon fal fa-wifi-slash"></i> {t("Error.NoConnection.Title")}</div></div>,
                        type: toast.TYPE.ERROR,
                        autoClose: 5000,
                    });
                });
        }
    };

    return (
        <Modal size="md" centered backdrop="static" keyboard={false} show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="h5 mb-0">
                        <i className="fad fa-school text-primary icon ml-2"></i>
                        {user.UserType?.Id === 2 ? (
                            t("Pages.UsersControl.action.changeTypeToSchoolTeacher")
                        ) : (
                            <>
                                {t("Pages.UsersControl.action.changeSchool")}:
                                <span className="text-primary mr-1">{user.Name}</span>
                            </>
                        )}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="widget widget-category mb-2">
                    <div className="widget-body">
                        <div className="form-group w-100">
                            <AsyncSelect
                                cacheOptions
                                isClearable={true}
                                name="SchoolsId"
                                placeholder={t('Pages.UsersControl.advancedSearch.School')}
                                isRtl={true}
                                isSearchable={true}
                                defaultOptions
                                loadOptions={handlePromiseSchoolOptions}
                                ref={schoolsSelectRef}
                                {...selectStyle}
                            />
                        </div>
                        <div className="form-group w-100 text-center">
                            <button className="custom-button btn-block" onClick={handleSaveSchool}>
                                <span>
                                    <i className="icon fal fa-save ml-1"></i>
                                    {t('Pages.UsersControl.notes.Send')}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ChangeSchoolModal;
